import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Typography, 
  Box, 
  Paper, 
  Tabs, 
  Tab, 
  Grid, 
  Card, 
  CardContent, 
  Divider,
  Chip,
  CircularProgress
} from '@mui/material';
import { School as SchoolIcon, Bookmark as BookmarkIcon, Analytics as AnalyticsIcon } from '@mui/icons-material';
import { useApp } from '../../context/AppContext';
import { useAuth } from '../../context/AuthContext';
import WrongAnswerNotebook from '../../components/study/WrongAnswerNotebook';
import { supabase } from '../../lib/supabase';
import LearningStats from './LearningStats';
import MyTermsList from './MyTermsList';

// 메인 페이지 컴포넌트
const MyLearningPage = () => {
  const [tabValue, setTabValue] = useState(0);
  const { user } = useAuth();

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  if (!user) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h5" align="center" sx={{ py: 8 }}>
          로그인이 필요한 서비스입니다.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <AnalyticsIcon color="primary" fontSize="large" />
          나의 학습 현황
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          용어 학습 상황, 오답노트, 나만의 용어와 정의를 한 곳에서 확인하세요.
        </Typography>
      </Box>

      <LearningStats />
      
      <Box sx={{ mt: 4, mb: 2 }}>
        <Paper sx={{ borderRadius: 2 }}>
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            indicatorColor="primary"
            textColor="primary"
            sx={{ borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab 
              icon={<SchoolIcon />} 
              label="오답노트" 
              iconPosition="start"
            />
            <Tab 
              icon={<BookmarkIcon />} 
              label="나만의 용어/정의" 
              iconPosition="start"
            />
          </Tabs>
          
          <Box sx={{ p: 3 }}>
            {tabValue === 0 ? (
              <WrongAnswerNotebook />
            ) : (
              <MyTermsList />
            )}
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default MyLearningPage; 